module.exports = __webpack_public_path__ + "static/media/Baskerville.3177db44.svg";